import React, {memo, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Ref} from '../../../utils/proptypes';
import {pushAnalyticsEvent} from '../../organisms/Analytics';
import {ZEPZ_PAYMENT_FORM} from '../../../consts';
import {TokenExIframe} from '../../organisms/ZepzForm/zepz-form.services';
import CvvHint from '../CvvHint';


const ZepzCvvField = ({
    iframe,
    id,
    name,
    forwardRef,
    translations: {
        cvvHelpInfo
    }
}) => {
    const onBlur = () => {
        pushAnalyticsEvent({
            interactionName: 'form tracking',
            formName: ZEPZ_PAYMENT_FORM,
            formField: name
        });
    };

    useEffect(() => {
      iframe?.onCvvBlur(onBlur);
    }, [iframe]);

    return (
        <div className="cvv-wrapper">
            <div id={id} ref={forwardRef} className="form-field-container" />
            <CvvHint translations={cvvHelpInfo} />
        </div>
    );
};

ZepzCvvField.propTypes = {
    iframe: PropTypes.instanceOf(TokenExIframe),
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    forwardRef: Ref.isRequired,
    translations: PropTypes.shape({
        cvvHelpInfo: PropTypes.shape({
            titleThreeDigits: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        }).isRequired
    }).isRequired
};

ZepzCvvField.defaultProps = {
    iframe: null
};

export default memo(ZepzCvvField);
